module.exports = __webpack_public_path__ + "static/media/developer.4b717344.png";